
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M22 44C9.85 44 0 34.15 0 22S9.85 0 22 0s22 9.85 22 22-9.85 22-22 22zm-5.333-31.333v18.666L31.333 22l-14.666-9.333z"}})])
      }
    
      }
    